export default {
  'mobileProfile.loremIpsum': 'Lorem Ipsum',
  'mobileProfile.lastUpdated': 'Last Updated ',
  'mobileProfile.next': 'next',
  'mobileProfile.contraryToPopular':
    'With Tripsi, you will soon see the whole world.',
  'mobileProfile.reverse': 'Reverse',
  'mobileProfile.issued': 'Issued',
  'mobileProfile.search': 'Search',
  'mobileProfile.myFavoriteTrips': 'My Favorite Trips',
  'mobileProfile.newYork': 'New York',
  'mobileProfile.losAngeles': 'Los Angeles',
  'mobileProfile.toronto': 'Toronto',
  'mobileProfile.lookToBook': 'Look to book',
  'mobileProfile.grade': 'Grade',
  'mobileProfile.totalPoint': 'Total point',
  'mobileProfile.activities': 'Activities',
  'mobileProfile.salaryCard': 'Salary card',
  'mobileProfile.weeks': 'weeks',
  'mobileProfile.searchTransaction': 'Search Transaction',
  'mobileProfile.march': 'March',
  'mobileProfile.receivedCashbook': 'Received cashbook',
  'mobileProfile.transferedMoney': 'Transfered money',
  'mobileProfile.uber': 'Uber',
  'mobileProfile.taxiService': 'Taxi service',
  'mobileProfile.morimoto': 'Morimoto',
  'mobileProfile.food&Drink': 'Food & Drink',
  'mobileProfile.receivedMoney': 'Received money',
  'mobileProfile.fromRobertFox': 'From Robert Fox',
  'mobileProfile.spotifySubscr': 'Spotify Subscr.',
  'mobileProfile.expenses': 'Expenses',
  'mobileProfile.subscription': 'subscription',
};
